import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Free-access ceiling: structured errors open the global prompt and are
// flattened to a string so existing `toast.error(detail)` calls stay safe.
api.interceptors.response.use(
  (r) => {
    if (r.config?.method === "post" && /\/(submit|answer)$/.test(r.config.url || "")) {
      window.dispatchEvent(new Event("sr:free-access-changed"));
    }
    return r;
  },
  (err) => {
    const d = err?.response?.data?.detail;
    if (d && typeof d === "object" && d.code) {
      window.dispatchEvent(new CustomEvent("sr:free-access", { detail: d }));
      err.response.data.detail = d.message;
      err.response.data.code = d.code;
      if (d.code === "free_ceiling_reached") window.dispatchEvent(new Event("sr:free-access-changed"));
    }
    return Promise.reject(err);
  },
);

export const setToken = (t) => {
  if (t) localStorage.setItem("sr_token", t);
  else localStorage.removeItem("sr_token");
};
